import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { BrowserServiceProvider } from '@mob-providers/browser-service/browser-service';

@Component({
	selector: 'terms-updated-modal',
	template: require('./terms-updated-modal.html')
})
export class TermsUpdatedModalComponent {
	constructor(
		private viewCtrl: ViewController,
		private browserService: BrowserServiceProvider
	) {}

	acceptTermsOfUse(data) {
		this.viewCtrl.dismiss(data);
	}

	openTermsOfUse(): void {
		this.browserService.openBrowser(
			'http://www.studioninja.co/terms-conditions/'
		);
	}

	openPrivacyPolicy(): void {
		this.browserService.openBrowser(
			'http://www.studioninja.co/privacy-policy/'
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./mobile/src/components/shared/terms-updated-modal/terms-updated-modal.ts